import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import PasscodePage from "@/pages/PasscodePage";
import DashboardPage from "@/pages/DashboardPage";
import { getStoredPasscode } from "@/lib/api";

function ProtectedRoute({ children }) {
  const [checking, setChecking] = useState(true);
  const [ok, setOk] = useState(false);
  useEffect(() => {
    setOk(Boolean(getStoredPasscode()));
    setChecking(false);
  }, []);
  if (checking) return null;
  if (!ok) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PasscodePage />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="light"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            border: "1px solid rgba(0,0,0,0.12)",
            color: "#0A0A0A",
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: "12px",
            borderRadius: 2,
          },
        }}
      />
    </div>
  );
}
